interface QualificationSectionProps {
  onOpenModal: () => void;
}

export default function QualificationSection({ onOpenModal }: QualificationSectionProps) {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-r from-orange-50 to-red-50">
      <div className="container">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="w-20 h-20 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-alert-line text-white text-4xl"></i>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Este diagnóstico <span className="gradient-text-orange">não é para qualquer empresa</span>
            </h2>
          </div>
          
          {/* Qualification Criteria */}
          <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12 mb-8">
            <p className="text-xl lg:text-2xl font-semibold text-gray-900 mb-8 text-center">
              Ele é indicado para empresários que:
            </p>
            
            <div className="space-y-4 max-w-2xl mx-auto">
              <div className="flex items-start gap-4 bg-green-50 rounded-xl p-4 border-l-4 border-green-500">
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-lg font-bold"></i>
                </div>
                <p className="text-lg text-gray-700 font-medium">
                  Faturam acima de R$50 mil por mês
                </p>
              </div>
              
              <div className="flex items-start gap-4 bg-green-50 rounded-xl p-4 border-l-4 border-green-500">
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-lg font-bold"></i>
                </div>
                <p className="text-lg text-gray-700 font-medium">
                  Estão cansados de depender de indicação
                </p>
              </div>
              
              <div className="flex items-start gap-4 bg-green-50 rounded-xl p-4 border-l-4 border-green-500">
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-lg font-bold"></i>
                </div>
                <p className="text-lg text-gray-700 font-medium">
                  Querem crescer com previsibilidade
                </p>
              </div>
              
              <div className="flex items-start gap-4 bg-green-50 rounded-xl p-4 border-l-4 border-green-500">
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-lg font-bold"></i>
                </div>
                <p className="text-lg text-gray-700 font-medium">
                  Estão dispostos a investir em estrutura
                </p>
              </div>
            </div>
          </div>
          
          {/* Exclusion Statement */}
          <div className="bg-gradient-to-r from-slate-900 to-slate-800 rounded-2xl p-8 lg:p-12 text-center mb-8">
            <p className="text-xl lg:text-2xl text-white leading-relaxed">
              Se você busca apenas <span className="text-red-400 font-bold">"mais seguidores"</span> ou{' '}
              <span className="text-red-400 font-bold">"testar algo barato"</span>,<br />
              <span className="text-yellow-300 font-bold text-2xl mt-4 block">
                essa página não é para você.
              </span>
            </p>
          </div>
          
          {/* CTA */}
          <div className="text-center">
            <button 
              onClick={onOpenModal}
              className="bg-green-600 hover:bg-green-700 text-white text-lg px-10 py-5 rounded-lg font-bold transition-all duration-300 cursor-pointer"
            >
              <i className="ri-calendar-line mr-2"></i>
              AGENDAR REUNIÃO
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
